import type { ValidLocaleEnum } from '@snowit/models';

export const ALL_LANGUAGES = ['it', 'en', 'de', 'fr'] as const satisfies ValidLocaleEnum[];

export type Languages = (typeof ALL_LANGUAGES)[number];

export const LANGUAGES_ICONS: Record<Languages, string> = {
  it: '🇮🇹',
  en: '🇬🇧',
  de: '🇩🇪',
  fr: '🇫🇷',
};
